import React, { useState } from 'react';
import '../../styles/quiz-base.css';
import './pesoAtual.css';
import Footer from '../../components/footer/Footer';

const API_BASE = process.env.REACT_APP_API_BASE;

const PesoAtual = ({ onSucesso }) => {
  const [peso, setPeso] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleEnviar = async () => {
    const pesoNum = parseFloat(peso);
    if (isNaN(pesoNum) || pesoNum < 30 || pesoNum > 300) {
      setErro('Insira um peso válido entre 30kg e 300kg.');
      return;
    }

    setEnviando(true);
    setErro('');

    try {
      const resposta = await fetch(`${API_BASE}/salvar-etapa.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ campo: 'peso_atual', valor: pesoNum })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso();
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro de conexão com o servidor.');
    }

    setEnviando(false);
  };

  return (
    <div className="quiz-etapa">
      <img src="/assets/logo1.png" alt="Logo NutriFitMe" className="quiz-logo" />

      <div className="quiz-progresso">
        <div className="quiz-progresso-barra">
          <div className="quiz-progresso-preenchido" style={{ width: '57%' }}></div>
        </div>
        <div className="quiz-progresso-texto">4 de 7</div>
      </div>

      <h2 className="quiz-pergunta">Qual é o seu peso atual? (Kg)</h2>
      <p className="quiz-texto-extra">Isso nos ajuda a estimar suas necessidades energéticas.</p>

      <input
        type="number"
        className="quiz-input"
        placeholder="Ex: 72.5"
        value={peso}
        onChange={(e) => setPeso(e.target.value)}
        step="0.1"
        min="30"
        max="300"
      />

      {erro && <p className="quiz-erro">{erro}</p>}

      <button
        className={`quiz-botao ${peso && !enviando ? 'ativo' : ''}`}
        onClick={handleEnviar}
        disabled={!peso || enviando}
      >
        {enviando ? 'Enviando...' : 'Continuar'}
      </button>

      <div className="quiz-footer">
        <Footer />
      </div>
    </div>
  );
};

export default PesoAtual;
